export default "__VITE_ASSET__o_hu7Uob__"